<template>
  <wtFormLeft :hideHeader="true">
    <!-- SLOT DEFAULT -->
    <template slot="default">
        <b-card no-body>
            <b-tabs pills card vertical>
            <b-tab title="Tab 1" active><b-card-text>Tab contents 1</b-card-text></b-tab>
            <b-tab title="Tab 2"><b-card-text>Tab contents 2</b-card-text></b-tab>
            <b-tab title="Tab 3"><b-card-text>Tab contents 3</b-card-text></b-tab>
            </b-tabs>
        </b-card>
    </template>
  </wtFormLeft>
</template>

<script>
/** COMPONENTS - LAYOUT **/
import wtFormLeft from "@/components/forms/wtFormLeft";

export default {
  name: "NotificationsTab",
  props: {},
  components: { wtFormLeft },
  computed: { },
  data() {
    return { };
  },
  methods: { },
};
</script>